import { useEffect } from "react";
import { IDailyReoprts } from "../../../../../models/dashboard/staffReports/staffReports";
import { connect, useDispatch } from "react-redux";
import { setReportsDaily } from "../../../../../store/slices/master/reportSlice";
import { pageBlockId } from "../../../../../constants/pageBlocks";
import { ReportFrequency } from "../../../../../models/dashboard/adminDashboard";
import { getReports } from "../../../../../action/masters/reportActionCreator";
import { IReports } from "../../../../../models/master/reports";
import { baseURL } from "../../../../../constants/commonConstants";

const StaffDailyReportsViewAll = (props: IDailyReoprts) => {
  const { getDailyReports, dailyReports } = props;
  const dispatch = useDispatch();

  useEffect(() => {
    getDailyReports(
      pageBlockId.reportResources,
      undefined,
      ReportFrequency.Daily
    );
  }, []);

  useEffect(() => {
    return () => {
      dispatch(setReportsDaily([]));
    };
  }, []);
  return (
    <>
      <div className="widgets">
        <div className="title">
          <h2>All Daily Reports</h2>
        </div>
        <div className="card-wrap">
          <div className="row">
            {dailyReports?.map((report: IReports, index) => (
              <div className="report-all-card col-lg-12 mb-2" key={report.id}>
                <div className="card">
                  <div className="img">
                    <img src={baseURL + report.icon} alt="" />
                  </div>
                  <div className="desc">
                    <h3>{report.name}</h3>
                    <p>{report.description}</p>
                    <a
                      href={report.url}
                      target="_blank"
                       className="mt-3 btn-arrow btn-block-arrow"
                    >
                      <img
                        src="/assets/images/icon/arrow-right.svg"
                        alt=""
                      />
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

const mapDispatchToProps = {
  getDailyReports: (
    pageBlockId: number,
    noOfItems: number,
    ReportFrequency: number
  ) => getReports(undefined, pageBlockId, noOfItems, ReportFrequency),
};

function mapStateToProps(state: any) {
  return {
    dailyReports: state.report.dailyreports,
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StaffDailyReportsViewAll);
